import { Box } from '@mantine/core'

interface CardFooterProps {
  children: React.ReactNode
}

export function CardFooter({ children }: CardFooterProps) {
  return (
    <Box
      style={{
        backgroundColor: 'var(--ai-body-bg)',
        borderTop: '1px solid var(--ai-border-light)',
        padding: '10px 16px',
        borderRadius: '0 0 4px 4px',
      }}
    >
      {children}
    </Box>
  )
}
